import Axios from 'axios'
import Store from '@/store/index'
import User from '@/controlador/user'
import Router from '@/router'
import Funciones from '@/funciones/index'
import Aplicacion from '@/controlador/aplicacion'

const { checkrole, check_administrador } = Funciones

const url_api = ()=> { return Store.state.url_api }
const token = ()=> { return Store.state.token }
const user = ()=> { return Store.state.user }
const urlsb = ()=> { return Store.state.urlsb }
const proyecto_actual = ()=>{return Store.state.proyecto_actual }
const socket_pusher = ()=>{ return Store.state.pushersocket }
const temporal_tarea = ()=>{ return Store.state.temporaltarea }
const temporaltarea_chat = ()=>{ return Store.state.temporaltarea_chat }

const Tarea = {

    async index(json){

        Aplicacion.loading(true)

        await Axios.get(`${url_api()}index_task`,{'params':json,'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response =>{

            Aplicacion.loading(false)

            if(response.data.errores == 0){

                Store.commit('set_tareas',response.data.tareas)

                let todast = response.data.tareas
                let mt = todast.filter((t)=>{ return (t.principal === 'mastertarea')})
                
                Store.commit('set_master_tarea',mt)

            }
        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally()

    },

    //# consulta las tareas corriendo#//
    async index_runing(json){

        Aplicacion.loading(true)
            await Axios.get(`${url_api()}index_task_runing`,{'params':json,'headers':{'Authorization':`Bearer ${token()}`}})
        .then(response =>{

            Store.commit('set_tareas_temp',response.data.task_runing)
            Aplicacion.loading(false)
    
        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally()
    },

    async index_asignados(json){
        
        await Axios.get(`${url_api()}index_asignados`,{'params':json,'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            if(response.data.errores == 0){ Store.commit('set_asignados',response.data.asignados) }

        })
        .catch(error => {
          console.log(error)
          window.location.reload()
        })
        .finally()

    },

    async todas(){

        Aplicacion.mini_loading(true)
        
        await Axios.get(`${url_api()}index_todas`,{'params':{'pro':proyecto_actual().id},'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

                Aplicacion.mini_loading(false)

                if(response.data.errores == 0){

                    var todas = response.data.todas
                    var tareas = []
                    var compras = []

                    for(var x=0; x < todas.length; x++){ 
                        if(todas[x].tipo === 'tarea'){ tareas.push(todas[x]) }
                        if(todas[x].tipo === 'compra'){ compras.push(todas[x]) }
                    }

                    Store.commit('set_todas',todas)
                    Store.commit('set_tareas',tareas)
                    Store.commit('set_compras',compras)

                    var mt = todas.filter((y)=>{ return (y.principal == 'mastertarea')})
                    Store.commit('set_master_tarea',mt)

                    var mc = todas.filter((y)=>{ return (y.principal == 'mastercompra')})
                    Store.commit('set_master_compra',mc)

                }
        })
        .catch(error => {
          console.log(error)
          window.location.reload()
        })
        .finally()
        
    },

    async store(json){
            
        Aplicacion.loading(true)
        
        await Axios.post(`${url_api()}store_task`,json,{'headers':{'content-type':'application/json','X-Socket-ID':socket_pusher(),'Authorization':`Bearer ${token()}`}})
        .then(response => {
            
            Aplicacion.loading(false)

            if(response.data.errores == 0){
                Store.dispatch('guardar_nueva_tarea_pusher',[response.data.tarea])
                Store.dispatch('realizado')
            }

            if(response.data.errores == 300){
            
                var nlocal ={
                    'run':true,
                    'tipo':'alerta', 
                    'titulo':'Sincronización fallida con cliente',
                    'contenido':'',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }
                
                Store.commit('set_notificacion_local',nlocal)
            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally()

    },
      
    async update(json){

        Aplicacion.loading(true)

        await Axios.post(`${url_api()}update_task`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.loading(false)

            if(response.data.errores == 300){

                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'La tarea no existe!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 0){

                Store.dispatch('realizado')
                Store.commit('set_tareas',response.data.tareas)

            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally(()=> Store.commit('set_updatetask'))

    },

    async update_lite(json){

        Aplicacion.mini_loading(true)

        await Axios.put(`${url_api()}update_task_lite`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.mini_loading(false)

            if(response.data.errores == 300){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'Task no found!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 0){ Store.dispatch('realizado')}

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally(()=> Store.commit('set_updatetask'))
        
    },

    async delete(json){

        Aplicacion.mini_loading(true)

        await Axios.put(`${url_api()}delete_task`,json,{'headers':{'content-type':'application/json','X-Socket-ID':socket_pusher(),'Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.mini_loading(false)

            if(response.data.errores == 300){

                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'La tarea no existe!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 301){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'¡Sincronización fallida con cliente!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 0 || response.data.errores == 301){

                if(temporal_tarea().id == json.id){Store.commit('set_temptarea',{'id':0})}
                if(temporaltarea_chat().id == json.id){Store.commit('set_temptarea_chat',{'id':0})}

                Store.dispatch('borrar_tarea_pusher',[json]) 

            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally(()=> Store.commit('set_updatetask'))
        
    },

    async change_color(json){

        Aplicacion.mini_loading(true)

        await Axios.put(`${url_api()}updatetask_color`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.mini_loading(false)

            if(response.data.errores == 300){

                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'La tarea no existe!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 0){ Store.dispatch('realizado')}

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally(()=> Store.commit('set_updatetask'))
    },

    async posicionar(json){
            
        Aplicacion.loading(true)

        await Axios.put(`${url_api()}update_position_milestone`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.loading(false)

            if(response.data.errores == 0){
                
                Store.commit('set_tareas',response.data.tareas)
                Store.dispatch('realizado')
            }

            if(response.data.errores == 300){

                var nlocal ={
                    'run':true,
                    'tipo':'advertencia',
                    'titulo': user().email,
                    'contenido':'No se permite reubicar el milestone principal!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)
                Store.commit('set_tareas',response.data.tareas)

            }

        })
        .catch(error => {
            console.log(error) 
            window.location.reload()
        })
        .finally(()=> Store.commit('set_updatetask'))

    },
    
    async store_userxtask(json){
            
        Aplicacion.loading(true)

        await Axios.post(`${url_api()}store_userxtask`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.loading(false)

            if(response.data.errores == 300){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'La tarea no existe!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 500){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'No fue posible enviar la notificación!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)
                Store.commit('set_asignados',response.data.asignados)
            }

            if(response.data.errores == 200){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'El usuario ya fue asignado!',
                    'errores':[],
                    'tiempo':3000,
                    'cerrar':false
                }
                
                Store.commit('set_asignados',response.data.asignados)
                Store.commit('set_notificacion_local',nlocal)
            }

            if(response.data.errores == 0){
                var nlocal ={
                    'run':true,
                    'tipo':'informativo',
                    'titulo':'Se guardó el asignado!',
                    'contenido':'',
                    'errores':[],
                    'tiempo':3000,
                    'cerrar':false
                }
                
                Store.commit('set_asignados',response.data.asignados)
                Store.commit('set_notificacion_local',nlocal)

            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally()
            
    },
    
    async delete_userxtask(json){
            
        Aplicacion.loading(true)

        await Axios.post(`${url_api()}delete_userxtask`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.loading(false)

            if(response.data.errores == 300){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'La tarea no existe!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 400){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': user().email,
                    'contenido':'La asignación no existe!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 0){
                Store.commit('set_asignados',response.data.asignados)
                Store.dispatch('realizado')
            }

        })
        .catch(error => {
           console.log(error)
           window.location.reload()
        })
        .finally()

    },

    async index_iproyecto(json){

        await Axios.get(`${url_api()}index_iproyecto`,{'params':json,'headers':{'content-type':'application/json'}})
        .then(response => {

            Aplicacion.loading(false)

            if(response.data.errores == 0){

                Store.commit('set_pro_ip',response.data.proip)
                Store.commit('set_tareasip',response.data.tareasip)
                Store.commit('set_horasip',response.data.horasip)
                Store.commit('set_comprasip',response.data.comprasip)

                var nlocal ={
                    'run':true,
                    'tipo':'realizado',
                    'titulo': 'Asakaa | Invitado',
                    'contenido':'',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)

            }

            if(response.data.errores == 100){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': 'Asakaa | Invitado',
                    'contenido':'El proyecto no existe!',
                    'errores':[],
                    'tiempo':6000,
                    'cerrar':false
                }

                Store.commit('set_notificacion_local',nlocal)
            }

            if(response.data.errores == 200){
                var nlocal ={
                    'run':true,
                    'tipo':'alerta',
                    'titulo': 'Asakaa | Invitado',
                    'contenido':'Contraseña Incorrecta',
                    'errores':[],
                    'tiempo':6000,
                    'cerrar':false
                }
                Store.commit('set_notificacion_local',nlocal)
            }

        })
        .catch(error => {
            console.log(error)
            Store.dispatch('failrecap')
            window.location.reload()
        })
        .finally()
          
    }

}

export default Tarea